import React from 'react'
import { Link } from 'react-router-dom'
import { motion } from 'framer-motion' // Import Motion
import Mimi from '../../assets/mimi.png'; 
import { FaEye } from "react-icons/fa";
import { FiMessageCircle } from "react-icons/fi";

const HeroSection = () => {
  // Animation settings for a smooth fade-up effect
  const fadeInVariant = {
    hidden: { opacity: 0, y: 20 },
    visible: { 
      opacity: 1, 
      y: 0,
      transition: { duration: 2, ease: "easeOut" }
    }
  };

  return (
    <motion.section 
      className='home'
      initial="hidden"
      animate="visible"
      variants={fadeInVariant}
    >
        <div className="hero-grid h">
            <motion.div className="container p-2" variants={fadeInVariant}>
                <h1 className='h1-dark'>The Intersection of Code & Craft</h1>
                <h2 className='h2-primary'>Digital Skills Meet Technical Service</h2>
                <div className="wrapper">
                    <div className="description">
                        <p className="text-dark">
                            I am Prince Mwenyemali, the creative force behind Congolese Design. 
                            I bridge technical disciplines with high-impact visual communication, 
                            providing a unique fusion of Web Development, Graphic Design, 
                            and Electrical Engineering
                        </p>
                    </div>
                    <div className="btns">
                        <button className="primary btn">
                            <Link to="/portfolio">Portfolio {' '} <FaEye className='setting' /></Link>
                        </button>
                        <button className="secondary btn">
                            <Link to="/contact">Contact {' '} <FiMessageCircle className='setting'/></Link>
                        </button>
                    </div>
                </div>
            </motion.div>

            <motion.div 
                className="container"
                variants={fadeInVariant}
                transition={{ delay: 0.2 }} // Slight delay for the image
            >
                <div className="wrapper">
                    <img src={Mimi} alt="hero" className='hero-img'/>
                </div>
            </motion.div>
        </div>
    </motion.section>
  )
}

export default HeroSection